module.exports = __webpack_public_path__ + "static/media/pediatrie_3.e15e0d19.jpg";